var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#778091",
    fillRule: "evenodd",
    d: "M31.375 13.021c5.412-3.993 13.07-3.536 17.967 1.374 5.397 5.411 5.397 14.186 0 19.6L32.22 51.16a1.722 1.722 0 0 1-2.439 0L12.66 33.994c-5.398-5.413-5.398-14.188 0-19.6 4.897-4.909 12.554-5.366 17.967-1.373l.374.286.374-.286Zm15.528 18.541c4.057-4.07 4.057-10.668 0-14.735a10.363 10.363 0 0 0-14.682 0 1.722 1.722 0 0 1-2.439 0 10.365 10.365 0 0 0-14.684 0c-4.057 4.067-4.057 10.666 0 14.735l15.903 15.944 15.902-15.944Zm-9.516 5.82 8.06-8.08a1.722 1.722 0 0 0-2.439-2.432l-8.06 8.08a1.722 1.722 0 0 0 2.439 2.433Z",
    clipRule: "evenodd"
  })));
};
export default SvgHeart;